import { googleLoginOneTap } from '@eventbrite/social-login-facebook';
import {
    GA_GOOGLE_ONE_TAP_NOT_BLOCKED,
    GA_GOOGLE_ONE_TAP_NOT_DISPLAYED,
    GA_GOOGLE_ONE_TAP_TRIGGERED,
} from '../constants/analytics';
import { IAllContextsProps } from '../constants/interfaces';
import { trackGeneralAuthAction } from '../tracking/general';
import { trackSocialError } from '../tracking/social';
import { socialProviderClickAction } from './social';
import { socialConnectVerifiedAction } from './socialHandlers';

/**
 * Load Google OneTap component
 */
export const loadGoogleOneTap = (contexts: IAllContextsProps) => {
    const socialSSOSettings = contexts?.configContext?.social?.SSOSettings;
    const analytics = contexts?.configContext?.analytics;

    if (socialSSOSettings?.google) {
        const clientId = socialSSOSettings.google?.clientId;

        /* istanbul ignore next */
        const onReturn = (
            socialProvider: string,
            stateFromProvider: any,
            isOneTap = false,
        ) => {
            socialProviderClickAction({
                socialProvider,
                stateFromProvider,
                isOneTap,
                contexts,
            });
        };

        /* istanbul ignore next */
        const onVerified = (socialProvider: string, socialResponse: any) => {
            socialConnectVerifiedAction({
                socialProvider,
                socialResponse,
                contexts,
            });
        };

        /* istanbul ignore next */
        const onTriggered = (socialProvider: string) => {
            trackSocialError({
                analytics,
                socialProvider,
                action: GA_GOOGLE_ONE_TAP_TRIGGERED,
            });
        };

        /* istanbul ignore next */
        const onNoDisplayed = (label: string) => {
            trackGeneralAuthAction({
                analytics,
                action: GA_GOOGLE_ONE_TAP_NOT_DISPLAYED,
                label,
            });
        };

        /* istanbul ignore next */
        const onBlocked = (label: string) => {
            trackGeneralAuthAction({
                analytics,
                action: GA_GOOGLE_ONE_TAP_NOT_BLOCKED,
                label,
            });
        };

        googleLoginOneTap({
            clientId,
            onReturn,
            onVerified,
            onTriggered,
            onNoDisplayed,
            onBlocked,
        });
    }
};
